/* Qapary · guía de tallas: helpers compartidos + dos usos.
   1) Panel de la ficha ([data-guia-tallas]): tabla por talla, pestañas, unidades y la talla elegida resaltada.
      Abrir y cerrar lo maneja window.qapary.paneles (qapary.js) con data-abrir="guia-tallas".
   2) Página /pages/guia-tallas ([data-guia-pagina]): selector de estilo y la tabla de ese estilo con cm / pulg.
   Datos de ambos: snippets/guia-tallas-datos.liquid (pulgadas, prenda extendida, contornos ya × 2). */
(function () {
  'use strict';

  /* ---- Helpers compartidos ---- */
  // XXL y 2XL son la misma talla: la ficha de fábrica dice XXL, la tienda puede decir 2XL.
  const norm = (t) => {
    const s = String(t || '').trim().toUpperCase();
    return { '2XL': 'XXL', XXXL: '3XL' }[s] || s;
  };
  const coma = (n) => String(n).replace('.', ',');
  const formatear = (pulg, unidad) => {
    if (typeof pulg !== 'number' || !isFinite(pulg)) return '—';
    if (unidad === 'pulg') return coma(pulg.toFixed(1));
    const cm = Math.round(pulg * 2.54 * 2) / 2; // a medio centímetro
    return coma(Number.isInteger(cm) ? cm : cm.toFixed(1));
  };
  // Nota de tolerancia en la unidad elegida: " Tolerancia de ± 1,3 cm." o "" si el estilo no la trae.
  const tolerancia = (datos, unidad) => {
    const rango = datos && Array.isArray(datos.tolerancia_pulg) ? datos.tolerancia_pulg : null;
    if (!rango) return '';
    const [min, max] = rango.map((v) => (unidad === 'cm' ? coma((Math.round(v * 2.54 * 10) / 10).toFixed(1)) : coma(Number(v).toFixed(2).replace(/0$/, ''))));
    return ` Tolerancia de ± ${min === max ? min : min + ' a ' + max} ${unidad === 'cm' ? 'cm' : 'pulg'}.`;
  };
  const leerJSON = (nodo) => {
    try {
      let d = nodo ? JSON.parse(nodo.textContent) : null;
      if (typeof d === 'string') d = JSON.parse(d); // metafield guardado como texto
      return d;
    } catch (e) { return null; }
  };

  iniciarPagina();
  iniciarPanel();

  /* ================= Página de guía de tallas ================= */
  function iniciarPagina() {
    const raiz = document.querySelector('[data-guia-pagina]');
    if (!raiz) return;
    const q = (s) => raiz.querySelector(s);
    const qa = (s) => Array.from(raiz.querySelectorAll(s));
    const estilos = leerJSON(q('[data-guia-estilos]')) || {};
    const opciones = qa('[data-guia-estilo-opcion]');
    const tabla = q('[data-guia-tabla="pagina"]');
    if (!tabla || !opciones.length) return;
    let unidad = 'cm';
    let actual = null;

    function celda(tag, texto, attrs) {
      const el = document.createElement(tag);
      el.textContent = texto;
      Object.keys(attrs || {}).forEach((k) => el.setAttribute(k, attrs[k]));
      return el;
    }
    function pintar() {
      const opcion = opciones.find((o) => o.value === actual);
      const datos = estilos[actual];
      opciones.forEach((o) => { const chip = o.closest('.chip'); if (chip) chip.classList.toggle('chip--activo', o.checked); });
      qa('[data-guia-estilo-nombre]').forEach((el) => { el.textContent = opcion ? opcion.dataset.nombre : ''; });
      qa('[data-guia-estilo-descripcion]').forEach((el) => { el.textContent = opcion ? opcion.dataset.descripcion : ''; });
      qa('[data-guia-unidad]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.guiaUnidad === unidad)));
      qa('[data-guia-unidad-larga]').forEach((el) => { el.textContent = unidad === 'cm' ? 'centímetros' : 'pulgadas'; });
      const thead = tabla.tHead || tabla.createTHead();
      const tbody = tabla.tBodies[0] || tabla.createTBody();
      thead.textContent = '';
      tbody.textContent = '';
      if (!datos || !Array.isArray(datos.filas)) return;
      const tallas = datos.tallas || [];
      const cabecera = document.createElement('tr');
      cabecera.appendChild(celda('th', unidad === 'cm' ? 'cm' : 'pulg', { scope: 'col' }));
      tallas.forEach((t) => cabecera.appendChild(celda('th', t, { scope: 'col' })));
      thead.appendChild(cabecera);
      datos.filas.forEach((fila) => {
        const tr = document.createElement('tr');
        const porTalla = {};
        Object.keys(fila.pulg || {}).forEach((t) => { porTalla[norm(t)] = fila.pulg[t]; });
        tr.appendChild(celda('th', fila.etiqueta || fila.id, { scope: 'row' }));
        tallas.forEach((t) => tr.appendChild(celda('td', formatear(porTalla[norm(t)], unidad))));
        tbody.appendChild(tr);
      });
      const tol = q('[data-guia-tolerancia]');
      if (tol) tol.textContent = tolerancia(datos, unidad);
      const notas = q('[data-guia-notas]');
      if (notas) {
        notas.textContent = '';
        (datos.notas || []).forEach((n) => notas.appendChild(celda('li', n)));
        notas.hidden = !(datos.notas || []).length;
      }
      const wa = q('[data-guia-whatsapp]');
      if (wa && wa.dataset.plantilla && wa.dataset.telefono) {
        const texto = wa.dataset.plantilla.replace('[estilo]', opcion ? opcion.dataset.nombre : '');
        wa.href = `https://api.whatsapp.com/send?phone=${wa.dataset.telefono}&text=${encodeURIComponent(texto)}`;
      }
    }

    // Estilo de entrada: ?estilo=amore en la URL (así la ficha puede enlazar directo) o el marcado por defecto.
    const pedido = new URLSearchParams(window.location.search).get('estilo');
    const porUrl = pedido && opciones.find((o) => o.value === String(pedido).toUpperCase() || o.dataset.nombre.toLowerCase() === String(pedido).toLowerCase());
    const inicial = porUrl || opciones.find((o) => o.checked) || opciones[0];
    inicial.checked = true;
    actual = inicial.value;

    opciones.forEach((o) => o.addEventListener('change', () => {
      if (!o.checked) return;
      actual = o.value;
      pintar();
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('estilo', o.dataset.nombre.toLowerCase());
        window.history.replaceState(null, '', url);
      } catch (e) { /* sin history: no pasa nada */ }
    }));
    qa('[data-guia-unidad]').forEach((b) => b.addEventListener('click', () => { unidad = b.dataset.guiaUnidad; pintar(); }));
    raiz.classList.add('guia--lista');
    pintar();
  }

  /* ================= Panel de la ficha ================= */
  function iniciarPanel() {
    const panel = document.querySelector('[data-guia-tallas]');
    if (!panel) return;
    const q = (s, r = panel) => r.querySelector(s);
    const qa = (s, r = panel) => Array.from(r.querySelectorAll(s));

    /* ---- Datos: metafield del producto o estilo de fábrica (pulgadas, contornos ya × 2) ---- */
    const datos = leerJSON(q('[data-guia-datos]'));
    const valores = {};
    if (datos && Array.isArray(datos.filas)) {
      datos.filas.forEach((fila) => {
        const porTalla = {};
        Object.keys(fila.pulg || {}).forEach((t) => { porTalla[norm(t)] = fila.pulg[t]; });
        valores[fila.id] = porTalla;
        const tr = q(`[data-guia-tabla="prenda"] [data-fila="${fila.id}"]`);
        const th = tr && q('[data-fila-etiqueta]', tr);
        if (th && fila.etiqueta) th.textContent = fila.etiqueta;
      });
    }

    // Medidas del cuerpo (solo si la pestaña está activa en el snippet): centímetros, [mínimo, máximo] por talla.
    const cuerpo = leerJSON(q('[data-guia-cuerpo]'));
    const formatearRango = (cm, unidad) => {
      if (!Array.isArray(cm) || cm.length !== 2 || !cm.every((v) => typeof v === 'number' && isFinite(v))) return '—';
      const [a, b] = cm.map((v) => (unidad === 'pulg' ? coma((v / 2.54).toFixed(1)) : coma(v)));
      return a === b ? a : `${a} a ${b}`;
    };

    /* ---- Unidades ---- */
    let unidad = 'cm';
    function pintar() {
      qa('[data-guia-tabla="prenda"] tbody tr').forEach((tr) => {
        const fila = valores[tr.dataset.fila] || {};
        qa('td[data-talla]', tr).forEach((td) => { td.textContent = formatear(fila[norm(td.dataset.talla)], unidad); });
      });
      qa('[data-guia-tabla="cuerpo"] tbody tr').forEach((tr) => {
        const fila = {};
        Object.keys((cuerpo && cuerpo[tr.dataset.fila]) || {}).forEach((t) => { fila[norm(t)] = cuerpo[tr.dataset.fila][t]; });
        qa('td[data-talla]', tr).forEach((td) => { td.textContent = formatearRango(fila[norm(td.dataset.talla)], unidad); });
      });
      qa('[data-guia-unidad-corta]').forEach((el) => { el.textContent = unidad === 'cm' ? 'cm' : 'pulg'; });
      qa('[data-guia-unidad-larga]').forEach((el) => { el.textContent = unidad === 'cm' ? 'centímetros' : 'pulgadas'; });
      qa('[data-guia-unidad]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.guiaUnidad === unidad)));
      const tol = q('[data-guia-tolerancia]');
      if (tol) tol.textContent = tolerancia(datos, unidad);
    }
    qa('[data-guia-unidad]').forEach((b) => b.addEventListener('click', () => { unidad = b.dataset.guiaUnidad; pintar(); }));

    const notas = q('[data-guia-notas]');
    if (notas && datos && Array.isArray(datos.notas) && datos.notas.length) {
      datos.notas.forEach((n) => { const li = document.createElement('li'); li.textContent = n; notas.appendChild(li); });
      notas.hidden = false;
    }

    /* ---- Pestañas accesibles: clic, flechas, Inicio y Fin ---- */
    const tabs = qa('[data-guia-tab]');
    function elegirTab(tab, enfocar) {
      tabs.forEach((t) => {
        const activa = t === tab;
        t.setAttribute('aria-selected', String(activa));
        t.tabIndex = activa ? 0 : -1;
        const destino = document.getElementById(t.getAttribute('aria-controls'));
        if (destino) destino.hidden = !activa;
      });
      if (enfocar) tab.focus();
    }
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => elegirTab(tab, false));
      tab.addEventListener('keydown', (e) => {
        let j = null;
        if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = tabs.length - 1;
        if (j === null) return;
        e.preventDefault();
        elegirTab(tabs[j], true);
      });
    });

    /* ---- La talla elegida en la ficha se resalta en las dos tablas ---- */
    const ficha = document.querySelector('[data-ficha]') || document;
    function tallaElegida() {
      const r = ficha.querySelector('[data-opcion-es-talla] input:checked');
      return r ? r.value : '';
    }
    function marcar() {
      const elegida = norm(tallaElegida());
      qa('[data-talla]').forEach((celda) => {
        const activa = elegida !== '' && norm(celda.dataset.talla) === elegida;
        celda.classList.toggle('guia-tabla__col--activa', activa);
        if (celda.tagName === 'TH') {
          if (activa) celda.setAttribute('aria-current', 'true'); else celda.removeAttribute('aria-current');
        }
      });
    }
    ficha.querySelectorAll('[data-opcion-es-talla] input').forEach((r) => r.addEventListener('change', marcar));

    // Quien abre recibe el foco antes (Safari no enfoca botones al hacer clic): al cerrar, el foco vuelve a él.
    // "Guía de tallas" abre arriba del todo. "¿Dudas entre dos?" (data-guia-ayuda) abre ya en el bloque de WhatsApp,
    // con el foco en su botón. El scroll va en la tarea siguiente, cuando qapary.js ya mostró el panel; el foco,
    // después del que pone qapary.js a los 30 ms.
    const hoja = q('.guia-tallas__panel');
    const cabecera = q('.guia-tallas__cabecera');
    const ayuda = q('.guia-tallas__ayuda');
    const whatsapp = q('[data-whatsapp-talla]');
    document.querySelectorAll(`[data-abrir="${panel.id}"]`).forEach((b) => b.addEventListener('click', () => {
      b.focus(); marcar();
      const aAyuda = b.hasAttribute('data-guia-ayuda') && ayuda && whatsapp;
      setTimeout(() => {
        if (!hoja) return;
        hoja.scrollTop = aAyuda ? ayuda.offsetTop - (cabecera ? cabecera.offsetHeight : 0) - 16 : 0;
      }, 0);
      if (aAyuda) setTimeout(() => whatsapp.focus({ preventScroll: true }), 80);
    }));

    pintar();
    marcar();
  }
})();
